import {
  Card,
  CardContent,
  Container,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import Slider from "react-slick";
interface StaffListProps {}

const StaffList: React.FC<StaffListProps> = (props) => {
  const slickStaffSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const staffs = [
    {
      name: "Đào Văn Khang",
      role: "Manager",
      content: "Quản lý bộ phận kỹ thuật viên",
      image: "/images/staff1.png",
    },
    {
      name: "Thạch Ngọc Văn",
      role: "Ktv",
      content: "Chuyên viên lắp đặt - bảo trì tủ đông",
      image: "/images/staff2.png",
    },
    {
      name: "Trần Thái Thịnh",
      role: "Ktv",
      content: "Chuyên viên lắp đặt - bảo trì máy giặt.",
      image: "/images/staff3.png",
    },
    {
      name: "Nguyễn Nhật",
      role: "Ktv",
      content: "Chuyên viên lắp đặt - bảo trì máy lạnh",
      image: "/images/staff4.png",
    },
    {
      name: "Trần Văn Ngọc",
      role: "Ktv",
      content: "Nhân viên quản lý kho linh kiện thiết bị điện lạnh",
      image: "/images/staff5.png",
    },
    {
      name: "Nguyễn Hải",
      role: "Ktv",
      content: "Chuyên viên tư vấn, thiết kế và lắp đặt hệ thống máy lạnh",
      image: "/images/staff6.png",
    },
    {
      name: "Hứa Văn Tâm",
      role: "Ktv",
      content: "Chuyên viên tư vấn lắp đặt dịch vụ dành cho hệ thống máy lạnh",
      image: "/images/staff7.png",
    },
  ];
  return (
    <section id="staffs" className=" bg-white">
      <Container className="pt-[50px] pb-5">
        <Container className="flex flex-col lg:flex-row items-center w-full pb-10">
          <Typography
            variant="h4"
            align="left"
            style={{ whiteSpace: "pre-line" }}
            className="hidden lg:block !w-1/2  !font-black text-gray-600"
          >
            {" Đội ngũ kĩ thuật viên \nchuyên nghiệp"}
          </Typography>
          <Typography
            variant="h6"
            align="left"
            style={{ whiteSpace: "pre-line" }}
            className="w-full lg:hidden  !font-black text-gray-600"
          >
            {" Đội ngũ kĩ thuật viên chuyên nghiệp"}
          </Typography>

          <Container className="w-full lg:!w-1/2 !p-0">
            <Typography
              variant="h6"
              align="left"
              className="hidden lg:block mb-12 text-gray-600  !font-bold"
            >
              Đội ngũ chuyên gia
            </Typography>
            <Typography
              variant="subtitle1"
              align="left"
              className="mb-12 text-gray-600 "
            >
              Chúng tôi có đội ngũ kỹ thuật viên chuyên nghiệp đảm bảo mang lại
              sự hài lòng nhất cho quí khách hàng.
            </Typography>
          </Container>
        </Container>
        <Divider className="" />
        <Slider {...slickStaffSettings} className="pt-10">
          {staffs.map((staff, index) => (
            <Card
              className="!flex !flex-col !items-center !justify-center rounded-3xl overflow-hidden lg:max-w-xs text-gray-800"
              elevation={0}
            >
              <img
                src={staff.image}
                alt={staff.name}
                className="w-64 h-64 rounded-full shadow-xl items-center"
              />
              <CardContent className="px-6 space-y-1">
                <h2 className="text-xl font-semibold text-center">
                  {staff.name}
                </h2>
                <div className="flex space-x-1 text-yellow-500 text-center"></div>
                <p className="text-sm text-gray-600 leading-relaxed text-center">
                  {staff.content}
                </p>
              </CardContent>
            </Card>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default StaffList;
